import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PageTitle from "../../../layouts/PageTitle";

const PunchLocation = () => {
  const { state } = useLocation();
  const navigate = useNavigate();

  if (!state || state.lat == null || state.lng == null) {
    return (
      <>
        <PageTitle activeMenu="Punch Location" motherMenu="Attendance" />
        <div className="card">
          <div className="card-body text-center py-5">
            <p className="text-muted mb-3">
              No location was passed to this page — open it from a punch
              location tag on the Daily Roster instead of navigating here
              directly.
            </p>
            <button
              className="btn btn-outline-primary"
              onClick={() => navigate("/staff/attendance/roster")}
            >
              Back to Daily Roster
            </button>
          </div>
        </div>
      </>
    );
  }

  const { employeeName, label, lat, lng, withinGeofence, address, time } = state;
  const outside = withinGeofence === false;
  const mapsLink = `https://www.google.com/maps?q=${lat},${lng}`;
  const embedSrc = `https://www.google.com/maps?q=${lat},${lng}&z=17&output=embed`;

  return (
    <>
      <PageTitle activeMenu="Punch Location" motherMenu="Attendance" />
      <div className="card">
        <div className="card-header d-flex flex-wrap align-items-center justify-content-between gap-2">
          <div>
            <h4 className="card-title mb-0">
              {employeeName} — Punch {label === "In" ? "In" : "Out"} Location
            </h4>
            <small className="text-muted">
              {time ? new Date(time).toLocaleString() : "—"}
            </small>
          </div>
          <span
            className="badge"
            style={{
              backgroundColor: outside ? "#f32d2d" : "#2bc155",
              color: "#fff",
            }}
          >
            {outside ? "Outside work location" : "Within work location"}
          </span>
        </div>
        <div className="card-body">
          {address && (
            <div className="mb-2 text-muted">
              <i className="fas fa-map-marker-alt me-1" />
              {address}
            </div>
          )}
          <div className="mb-3 d-flex flex-wrap gap-3 align-items-center">
            <span className="text-muted small">
              Coordinates: <strong>{lat.toFixed(6)}, {lng.toFixed(6)}</strong>
            </span>
            <a
              href={mapsLink}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-sm btn-outline-primary"
            >
              <i className="fas fa-external-link-alt me-1" />
              Open in Google Maps
            </a>
            <button
              className="btn btn-sm btn-outline-secondary"
              onClick={() => navigate(-1)}
            >
              Back
            </button>
          </div>
          <div style={{ width: "100%", height: 480, borderRadius: 8, overflow: "hidden" }}>
            <iframe
              title="Punch location map"
              src={embedSrc}
              width="100%"
              height="100%"
              style={{ border: 0 }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default PunchLocation;
